import { render } from "./ScrollLink.vue?vue&type=template&id=43fdb190"
import script from "./ScrollLink.vue?vue&type=script&lang=js"
export * from "./ScrollLink.vue?vue&type=script&lang=js"

import "./ScrollLink.vue?vue&type=style&index=0&id=43fdb190&lang=scss"
script.render = render

export default script